import { FC, ReactNode } from 'react';

import { StyledScrollableStack } from '../../SelectableListStep.styles';

export type SelectableListStepScrollableListProps = {
	itemCount: number;
	children: ReactNode;
};

/** Scrollable `<ul>` with inset shadow when there are more than three items. */
export const ScrollableList: FC<SelectableListStepScrollableListProps> = ({ itemCount, children }) => (
	<StyledScrollableStack spacing="tight" amountOfItems={itemCount} vertical>
		{children}
	</StyledScrollableStack>
);

ScrollableList.displayName = 'SelectableListStep.ScrollableList';
